import { apiClient } from '../utils/api-client';

export interface FollowingItem {
  id: string;
  type: 'gym' | 'crag' | 'competition' | 'location' | 'user';
  attributes: {
    name?: string;
    slug: string;
    location_type?: string;
    username?: string;
    full_name?: string;
    avatar_url: string | null;
  };
}

export interface FollowingsResponse {
  data: FollowingItem[];
  meta: {
    page: number;
    per_page: number;
    total: number;
    has_more: boolean;
  };
}

export const followingsService = {
  async getFollowings(page: number = 1): Promise<FollowingsResponse> {
    const response = await apiClient.get(`/api/followings?page=${page}`, {
      requireAuth: true,
    });
    // console.log('API response for followings:', await response.json());
    return await response.json() as FollowingsResponse;
  },
};
